import { TERMINOLOGY_TOKENS } from "@app/shared/terminology/terminology-token.catalog";
import { defineTerminologyUsage, TERMINOLOGY_CONFIGURATION_CODES, TERMINOLOGY_USAGE_KINDS } from "@app/shared/terminology/terminology-usage";
export const POST_HEARING_ACTIONS_TERMINOLOGY = {
  status: defineTerminologyUsage({ usageId: "phms.post-hearing.actions.status", token: TERMINOLOGY_TOKENS.operationalStatus,
    fallbackText: "Status", kind: TERMINOLOGY_USAGE_KINDS.gridHeader, configurationCode: TERMINOLOGY_CONFIGURATION_CODES.programPack,
    surface: { featureCode: "phms", surfaceCode: "post-hearing-actions", componentCode: "PostHearingActionsSectionComponent",
      locations: [{ kind: "route", value: "/phms/hearing-detail" }] } }),
} as const;
